export const HRISContent = {
  heroContent: {
    title: "SIMPLIFY HR PROCESSES THROUGH DIGITAL INNOVATION",
    description:
      "An integrated Human Resource Information System for better data management, reporting, and employee engagement.",
    backgroundImage: "/assets/images/HRIT.jpg",
  },

  footerContent: {
    backgroundColor: "#96B596",
    text: "© 2025 Tenth Corporation Inc. All Rights Reserved",
  },

  overviewCards: [
    {
      title: "HR Management",
      description: "All HR Department to manage and administer HR processes faster and conveniently",
      image: "/assets/images/HRIT.jpg",
    },
    {
      title: "Employee Services",
      description: "Access of personal information and avail HR services 24/7",
      image: "/assets/images/empservices.jpg",
    },
    {
      title: "Managerial Services",
      description: "Extend HR services to Managers and Supervisors allowing online services such as approval of requests",
      image: "/assets/images/Solutionsbg.jpg",
    },
    {
      title: "Applicant Services",
      description: "Enables seamless and automatic publishing of vacancy and job opportunities.",
      image: "/assets/images/appservices.webp",
    },
  ],

  futureCards: [
    { title: "Automation and Digital Approvals", image: "/assets/images/FutureWork1.png" },
    { title: "Employee Self-Service", image: "/assets/images/FutureWork2.png" },
    { title: "Hybrid Setup", image: "/assets/images/FutureWork3.png" },
    { title: "Environmental Friendly and Paperless", image: "/assets/images/FutureWork4.png" },
    { title: "Data Analytics", image: "/assets/images/FutureWork5.png" },
  ],

  systemCapabilities: [
    { title: "Employee Record Management", icon: "bi-person-lines-fill" },
    { title: "Employee Self-Service", icon: "bi-person-fill-gear" },
    { title: "Succession Management", icon: "bi bi-diagram-3-fill" },
    { title: "Learning and Development Plans", icon: "bi-journal-bookmark-fill" },
    { title: "Wellness and Relations", icon: "bi-heart-pulse-fill" },
    { title: "Leave, Timekeeping, and Attendance Management", icon: "bi-calendar-check-fill" },
    { title: "Recruitment, Selection and Placement", icon: "bi-person-plus-fill" },
    { title: "Payroll Management", icon: "bi-cash-stack" },
  ],

  keySystemModules: [
    {
      title: "Payroll System",
      features: [
        "Centralizes resident records, household mapping, and family profiles.",
        "Automates demographic profiling and health information updates.",
        "Maintains social welfare and residency validation data.",
        "Integrates digital ID system for streamlined resident identification.",
        "Ensures accurate reporting and compliance with data standards.",
      ],
    },
    {
      title: "Employee Records Management",
      features: [
        "Simplifies tracking and updating of employee information and records.",
        "Maintains 201 files, career movements, service records, and plantilla history.",
        "Streamlines HR tasks, employee requests, and approvals.",
        "Captures and uploads digital documents such as certificates, diplomas, and IDs.",
        "Processes action notices for promotions, transfers, and contract renewals.",
      ],
    },
    {
      title: "HR Reports",
      features: [
        "Payroll Reports",
        "Timekeeping Reports",
        "Training Reports",
        "Recruitment Reports",
        "201 Reports",
        "Performance Management Reports",
        "Retirement / Separation Reports",
      ],
    },
  ],

  complianceItems: [
    {
      icon: "bi-file-earmark-text-fill",
      label: "Governments Requirements Complaint",
    },
    {
      icon: "bi-person-fill",
      label: "End to End Employee Journey",
    },
    {
      icon: "bi-lock-fill",
      label: "Data Privacy Act Complaint",
    },
  ],
};

HRISContent.dashboardImage = "/assets/images/SystemDashboard.jpg";
